/* global document */

import ReactDOM from 'react-dom';

// eslint-disable-next-line import/no-cycle
import Widget from './jordanRequestPricing/JordanRequestPricing';

const JordanRequestPricing = (props) =>
  ReactDOM.createPortal(
    <>
      <Widget slug={props.slug} />
    </>,
    document.getElementById('c7-request-pricing-jv')
  );

export default JordanRequestPricing;
